@if (apartment$() | async; as apartment) {
  <div class="p-6">

    <h1 class="font-bold text-3xl">{{ apartment.name }}</h1>
    <div class="flex flex-row justify-between">
      <div class="max-w-2xl">
        <div class="grid grid-cols-2 gap-y-6">
          <app-labeled label="Id" [value]="apartment.id"/>
          <app-labeled label="Status" [value]="apartment.status"></app-labeled>

          <app-labeled label="Last updated" [value]="apartment.lastUpdated | date"></app-labeled>
          <app-labeled label="Last updated" [value]="apartment.endDate | date"></app-labeled>
        </div>
      </div>
    </div>

      <h2 class="mt-12 text-xl font-medium">Eligibility</h2>
      <p-table [value]="apartment.unitTypes">
        <ng-template pTemplate="header">
          <tr>
            <td>
              Unit
            </td>
            <td>
              Min income
            </td>
            <td>
              Max income
            </td>
            <td>
              Asset limit
            </td>
            <td>
              Household size
            </td>
            <td>
              Monthly rent
            </td>
            <td>
              Estimated savings
            </td>
            <td>
              Available units
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-unitType [cTypedTableRow]="apartment.unitTypes">
          <tr>
            <td>{{ unitType.unitType }}</td>
            <td>{{ unitType.minIncome }}</td>
            <td>{{ unitType.maxIncome }}</td>
            <td>{{ unitType.assetLimit }}</td>
            <td>{{ unitType.householdSize }}</td>
            <td>{{ unitType.monthlyRent }}</td>
            <td>{{ unitType.estimatedSavings }}</td>
            <td>{{ unitType.unitsAvailable }}</td>
          </tr>
        </ng-template>
      </p-table>
  </div>
}
